import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './NotesPage.css'; // Add styling for this page

const NotesPage = () => {
  const location = useLocation();
  const { notes, treeName } = location.state || { notes: [], treeName: 'Tree' };

  const [selectedImage, setSelectedImage] = useState(null); // State to track clicked image
  const [hoveredNoteId, setHoveredNoteId] = useState(null); // State to track hovered note

  const handleImageClick = (photoBase64) => {
    setSelectedImage(photoBase64); // Set the clicked image for display
  };

  const closeImageModal = () => {
    setSelectedImage(null); // Close the modal
  };

  return (
    <div className="notes-page">
      <div className="lights-container">
        <video
          className="christmas-lights-video"
          autoPlay
          loop
          muted
          playsInline
          src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`}
        >
          <source src={`${process.env.PUBLIC_URL}/christmas_lights.mp4`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <header className="notes-header">
        <h1>{treeName} Memories</h1>
      </header>
      <div className="notes-container">
        {notes.length > 0 ? (
          notes.map((note) => (
            <div
              key={note.id}
              className={`note-card ${hoveredNoteId === note.id ? 'hovered' : ''}`}
              style={{
                backgroundImage: note.photoBase64
                  ? `url(data:image/jpeg;base64,${note.photoBase64})`
                  : 'none',
              }}
              onMouseEnter={() => setHoveredNoteId(note.id)} // Track hovered note
              onMouseLeave={() => setHoveredNoteId(null)} // Reset hovered note
              onClick={() => note.photoBase64 && handleImageClick(note.photoBase64)} // Handle click event
            >
              <div className="note-content">
                <h3>{note.name}</h3>
                <p>{note.content}</p>
              </div>
            </div>
          ))
        ) : (
          <p>No memories added yet</p>
        )}
      </div>

      {selectedImage && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="modal-content">
            <img
              src={`data:image/jpeg;base64,${selectedImage}`}
              alt="Selected Memory"
              className="modal-image"
            />
            <button className="close-modal" onClick={closeImageModal}>
              ✖ Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotesPage;
